const Input = (props) => {
  return (
    <input className={`form-control ${props.className || ""}`} {...props} />
  );
};

export default Input;
